<div
    class="modal-wrapper"
    role="dialog"
    aria-modal="true"
    aria-labelledby="selectCompanyRolesTitle"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <div class="modal-content">
        <div class="modal-header">
            <h2 id="selectCompanyRolesTitle">New Opportunity</h2>
            <div class="bar"></div>
            <button type="button" class="close-wrapper" (click)="close(undefined)" aria-label="Close modal">
                <div class="icon" [innerHTML]="closeIcon"></div>
            </button>
        </div>

        <div class="modal-body">
            <p>Select one or more Company Roles to pre-populate on the new Opportunity.</p>

            <lib-editor-item
                class="company-roles-field"
                [configItem]="rolesEditorItemConfig"
                [factory]="rolesEditorFactory"
                editorItemId="companyRoles"
                (valueChange)="onSelectedRolesChange(state.selectedRoles)"
            ></lib-editor-item>

            @if (state.isLoading) {
                <p aria-live="polite">Loading Company Roles…</p>
            } @else if (state.hasLoadError) {
                <p class="error" role="alert">
                    Could not load Company Roles.
                    <button type="button" class="retry-link" (click)="retryLoadRoleOptions()">Try again</button>
                </p>
            } @else if (!state.roleOptions.length) {
                <p role="status">
                    No Company Roles are available.
                    <button type="button" class="retry-link" (click)="retryLoadRoleOptions()">Try again</button>
                </p>
            } @else {
                @if (state.showValidationError) {
                    <p class="error" role="alert">Select at least one Company Role to continue.</p>
                }
            }
        </div>

        <div class="modal-footer">
            <button type="button" class="modal-button cancel" (click)="close(undefined)">Cancel</button>
            <button
                type="button"
                class="modal-button confirm"
                [disabled]="state.isLoading || state.hasLoadError || !state.roleOptions.length"
                (click)="onContinue()"
            >
                Continue
            </button>
        </div>
    </div>
</div>
